export default "__VITE_ASSET__DZOI2YKc__"